<!-- 客户伙伴 -->
<template>
    <div class='customerPartner'>
        <div class="banner">
            <img src="../../assets/aboutUs/customerPartner/客户伙伴banner.jpg" alt="">
            <div class="tip">
                <div class="title">客户伙伴</div>
                <div class="En">
                    <p>CUSTOMER</p>
                    <p>PARTNER</p>
                </div>
            </div>
        </div>
        <div class="main">
            <!-- <div class="all-title">客户满意是衡量一切工作的准绳</div> -->
            <div class="tjzz">
                <div class="title">客户满意是衡量一切工作的准绳</div>
                <div class="list">
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/DFL.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/宝龙地产.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/保利发展控股.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/碧桂园.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/大华集团.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/大悦城.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/弘阳地产.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/华润置地.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/金地集团.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/龙光.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/绿城中国.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/美的置业.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/上海城投.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/上海地产.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/石榴集团.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/首创置业.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/五矿地产.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/新希望地产.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/雅居乐.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中国地产.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中国金茂.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中国绿发.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中国铁建.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中海地产.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中建八局.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中建四局.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中建新疆建工.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/客户logo/中骏.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="tjzz">
                <div class="title">从上游到下游产业链的整体强健，是探见生存之本</div>
                <div class="list">
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/Group.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/Roto.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/安泰.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/栋梁铝业.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/广州白云.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/硅宝.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/海螺型材.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/合和.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/坚朗.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/金晶.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/立兴.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/南玻.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/实德集团.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/台玻.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/兴发.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/兴三星.png" alt="">
                        </div>
                    </div>
                    <div class="list-warp">
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/亚铝.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/阳光铝业.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/耀皮.png" alt="">
                        </div>
                        <div class="item">
                            <img src="../../assets/aboutUs/customerPartner/供应商logo/中财型材.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: '',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.customerPartner {
    width: 100%;

    .banner {
        width: 100%;
        height: calc(100vh - 48px);
        background-color: #999;
        margin-bottom: 20px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        .tip {
            position: absolute;
            bottom: 86px;
            right: 135px;
            width: 410px;
            height: 188px;
            background-color: rgb(35, 44, 223);
            border-radius: 12px;

            .title {
                text-align: left;
                font-size: 34px;
                color: #fff;
                margin: 50px 0 6px 50px;
            }

            .En {
                margin-left: 50px;

                p {
                    color: #fff;
                }
            }
        }
    }

    .main {
        width: 1200px;
        margin: 0 auto;

        .all-title {
            font-size: 32px;
            font-weight: bolder;
            text-align: center;
            margin: 40px auto;
        }

        .tjzz {
            margin-top: 80px;
            margin-bottom: 100px;

            .title {
                width: 100%;
                text-align: center;
                margin: 30px auto;
                font-weight: bolder;
                font-size: 28px;
                color: #000;
            }

            .list {

                display: flex;
                justify-content: space-between;

                .list-warp {
                    width: 19%;

                    .item {

                        img {
                            display: block;
                            margin: 20px auto;
                            width: 100%;
                            // height: 100px;
                            // object-fit: cover;
                        }
                    }
                }
            }

        }

    }


}
</style>